<template>
  <base-page
    :title="$t('common.services.plural')"
  >
    <template #actionButton>
      <v-btn
        outlined
        rounded
        color="primary"
        @click="$router.push({ name: 'create-service' })"
      >
        <v-icon left>
          add
        </v-icon>

        {{$t('common.add')}} {{$t('common.services.singular')}}
      </v-btn>
    </template>

    <template #main>
      <service-table />
    </template>
  </base-page>
</template>
<script>
  import BasePage from '@/views/BasePage.vue'
  import ServiceTable from '@/components/Service/ServiceTable.vue'

  export default {
    components: {
      BasePage,
      ServiceTable
    }
  }
</script>
